import React from "react";
import PrivacyStatement from "./PrivacyStatement";
import Terms from "./TermsOfUse";
import Footer from "./footer";

const privacyLink = "privacy-link";
const termsLink = "terms-link";

const Links = () => (
    <div>
        <a href={`#${termsLink}`}>Terms of Use</a> |{" "}
        <a href={`#${privacyLink}`}>Privacy</a>
    </div>
);

export default () => {
    return (
        <div>
            <Links />
            <Terms privacyLink={privacyLink} anchor={termsLink} />
            <PrivacyStatement anchor={privacyLink} />
            <Links />
            <Footer termsLink={termsLink} />
        </div>
    );
};
